/**
 * Shared mapping from spinner intensity (0..1) to feedback colour.
 *
 * Used by the canvas renderer (in-spinner "xN" tally) and the session
 * juice layer (floating "+N" pop) so both surfaces agree on what
 * "fast spin" looks like at any given intensity. Single source of
 * truth prevents the two from drifting if the colour ramp is later
 * tuned.
 */

export interface SpinIntensityThresholds {
  /** Below `warm`: cold colour. */
  warm: number;
  /** Below `hot`: warm colour. At/above: hot colour. */
  hot: number;
}

export const SPIN_INTENSITY_THRESHOLDS: SpinIntensityThresholds = {
  warm: 0.3,
  hot: 0.65,
};

export const SPIN_INTENSITY_COLOUR_COLD = '#16e0ff';
export const SPIN_INTENSITY_COLOUR_WARM = '#ffd84d';
export const SPIN_INTENSITY_COLOUR_HOT = '#ff2bd6';

export function spinIntensityColour(intensity: number): string {
  if (intensity > SPIN_INTENSITY_THRESHOLDS.hot) {
    return SPIN_INTENSITY_COLOUR_HOT;
  }
  if (intensity > SPIN_INTENSITY_THRESHOLDS.warm) {
    return SPIN_INTENSITY_COLOUR_WARM;
  }
  return SPIN_INTENSITY_COLOUR_COLD;
}
